import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setUser } from '../../features/api/user/userSlice'

export const InitializeStore = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const loggedInUser =
      JSON.parse(localStorage.getItem('supplyCornerBackOfficeUser')) || null

    dispatch(setUser(loggedInUser))
  }, [dispatch])

  return null
}
